// AuthenticatedRoute.tsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LoaderCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";


// Loading spinner component
function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen text-violet-700">
      <LoaderCircle size={48} className="animate-spin" />
    </div>
  );
}

export function AuthenticatedRoute({ children }: { children: React.ReactNode }) {
  // Use the auth context instead of directly calling useUnifiedAuth
  const { isAuthenticated, isLoading, error, authMode, isEnabled } = useAuth();
  const location = useLocation();
  const hasAuthCode = location.search.includes('code=');

  if (hasAuthCode) return <>{children}</>;
  if (isLoading) return <LoadingSpinner />;
  if (error) return <Navigate to="/unauthorized" />;
  if (!isAuthenticated && authMode === 'cognito') return null;
  if (!isEnabled) {
    return <Navigate to="/access-denied" />;
  }

  return <>{children}</>;
}